import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// ADS 디자인 시스템 폰트 작명 규칙 (display, heading, label, body, caption, title 등)
const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            // 해당 접두사가 붙은 text- 클래스는
            // '색상'이 아니라 '폰트 사이즈'로 인식하게 강제합니다.
            (value) =>
              /^(display|heading|label|body|caption|title)-/.test(value),
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs));
}
